__turbopack_context__.v({
  "backdrop": "Modal-module-scss-module__k1ZY8q__backdrop",
  "body": "Modal-module-scss-module__k1ZY8q__body",
  "description": "Modal-module-scss-module__k1ZY8q__description",
  "dialog": "Modal-module-scss-module__k1ZY8q__dialog",
  "fade-in": "Modal-module-scss-module__k1ZY8q__fade-in",
  "footer": "Modal-module-scss-module__k1ZY8q__footer",
  "header": "Modal-module-scss-module__k1ZY8q__header",
  "headerButton": "Modal-module-scss-module__k1ZY8q__headerButton",
  "headerInfo": "Modal-module-scss-module__k1ZY8q__headerInfo",
  "headerInfoCenter": "Modal-module-scss-module__k1ZY8q__headerInfoCenter",
  "modal": "Modal-module-scss-module__k1ZY8q__modal",
  "modalAppear": "Modal-module-scss-module__k1ZY8q__modalAppear",
  "modalAppearActive": "Modal-module-scss-module__k1ZY8q__modalAppearActive",
  "modalEnter": "Modal-module-scss-module__k1ZY8q__modalEnter",
  "modalEnterActive": "Modal-module-scss-module__k1ZY8q__modalEnterActive",
  "modalExit": "Modal-module-scss-module__k1ZY8q__modalExit",
  "modalExitActive": "Modal-module-scss-module__k1ZY8q__modalExitActive",
  "no-transform": "Modal-module-scss-module__k1ZY8q__no-transform",
  "rotate": "Modal-module-scss-module__k1ZY8q__rotate",
  "title": "Modal-module-scss-module__k1ZY8q__title",
});
